import { axiosDash } from "../axios";
import {
  ServiceRequest,
  getMachineFeStatusProps,
  getMachineFeStatusPropsResponse,
  getMachineFeInfoPropsResponse,
} from "../../utils/types/services";
import { MODEL_SERVICE_URLS } from "../../utils/constants";

/**
 * Obtiene el valor Fe proyectado en base a los parametros dados
 */
export const getMachineFeStatus = ({
  request = axiosDash.get,
  baseURL = MODEL_SERVICE_URLS.MACHINE_FE_STATUS,
  params,
  modelId,
}: getMachineFeStatusProps<getMachineFeStatusPropsResponse>): Promise<getMachineFeStatusPropsResponse> =>
  request(baseURL + "/" + modelId, {
    params,
  });

/**
 * Obtiene un array con los documentos de los modelos disponibles
 */
export const getMachineFeInfo = ({
  request = axiosDash.get,
  baseURL = MODEL_SERVICE_URLS.MACHINE_FE_STATUS_INFO,
}: ServiceRequest<getMachineFeInfoPropsResponse> = {}): Promise<getMachineFeInfoPropsResponse> =>
  request(baseURL);
